import list from './list/notificationListReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
});
